import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
};

const IconCircleCross: React.FC<IconProps> = () => {
    return (
        <svg
            width="50"
            height="50"
            viewBox="0 0 50 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="25" cy="25" r="25" fill="white" />
            <path
                d="M34.7081 33.2931C34.801 33.386 34.8747 33.4963 34.9249 33.6177C34.9752 33.7391 35.0011 33.8692 35.0011 34.0006C35.0011 34.132 34.9752 34.2621 34.9249 34.3835C34.8747 34.5048 34.801 34.6151 34.7081 34.7081C34.6151 34.801 34.5048 34.8747 34.3835 34.9249C34.2621 34.9752 34.132 35.0011 34.0006 35.0011C33.8692 35.0011 33.7391 34.9752 33.6177 34.9249C33.4963 34.8747 33.386 34.801 33.2931 34.7081L25.0006 26.4143L16.7081 34.7081C16.5204 34.8957 16.2659 35.0011 16.0006 35.0011C15.7352 35.0011 15.4807 34.8957 15.2931 34.7081C15.1054 34.5204 15 34.2659 15 34.0006C15 33.7352 15.1054 33.4807 15.2931 33.2931L23.5868 25.0006L15.2931 16.7081C15.1054 16.5204 15 16.2659 15 16.0006C15 15.7352 15.1054 15.4807 15.2931 15.2931C15.4807 15.1054 15.7352 15 16.0006 15C16.2659 15 16.5204 15.1054 16.7081 15.2931L25.0006 23.5868L33.2931 15.2931C33.4807 15.1054 33.7352 15 34.0006 15C34.2659 15 34.5204 15.1054 34.7081 15.2931C34.8957 15.4807 35.0011 15.7352 35.0011 16.0006C35.0011 16.2659 34.8957 16.5204 34.7081 16.7081L26.4143 25.0006L34.7081 33.2931Z"
                fill="#FF3589"
            />
        </svg>
    );
};

export default IconCircleCross;
